class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document.querySelector("main-collection")
      ? document.querySelector("main-collection").classList.add("loading")
      : null;
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderCustomFilters(html);
        FacetFiltersForm.renderProductCount(html);
        document
          .querySelector("collection-filters")
          .dispatchEvent(new Event("update:checkboxs"));

        window.dispatchEvent(new Event("resize"));
        removeInputTranslateRemove();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderCustomFilters(html);
    FacetFiltersForm.renderProductCount(html);
    document
      .querySelector("collection-filters")
      .dispatchEvent(new Event("update:checkboxs"));
    window.dispatchEvent(new Event("resize"));
    removeInputTranslateRemove();
  }

  static renderProductGridContainer(html) {
    document.getElementById("product-grid").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("product-grid").innerHTML;
    reloadPagination();
    removeInputTranslateRemove();
  }

  static renderCustomFilters(html) {
    const customFilters = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelectorAll(".filters-values__item");
    const buttonFilter = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelectorAll(".collection-filters__collection-name button");

    const labelsFilter = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelectorAll(
        "collection-filters.only-phone-flex .filter-group[data-type]"
      );

    customFilters.forEach((customFilter) => {
      const container = document.querySelectorAll(
        `.filters-values__item[data-type="${customFilter.dataset.type}"][data-tag="${customFilter.dataset.tag}"]`
      );
      container.forEach((element) => {
        element.innerHTML = customFilter.innerHTML;
      });
    });

    document.querySelectorAll(".facet-checkbox span").forEach((span) => {
      if (span.innerHTML.indexOf("(0)") > -1) {
        span.classList.add("disabled");
      } else {
        span.classList.remove("disabled");
      }
    });

    buttonFilter.forEach((button) => {
      document
        .querySelectorAll(".collection-filters__collection-name button")
        .forEach((element) => {
          element.innerHTML = button.innerHTML;
        });
    });

    // labelsFilter.forEach((label) => {
    //   document
    //     .querySelectorAll(
    //       `collection-filters.only-phone-flex .filter-group[data-type="${label.dataset.type}"][data-tag="${label.dataset.tag}"] label span`
    //     )
    //     .forEach((element) => {
    //       element.innerHTML = label.querySelector("label span").innerHTML;
    //     });
    // });

    if (document.querySelector(".reset-filters")) {
      document.querySelector(".reset-filters").addEventListener("click", () => {
        document.querySelector(".active-facets__button-remove").click();
      });
    }

    document
      .querySelectorAll(
        "[data-type] #Filter-Prix-GTE, [data-type] #Filter-Prix-LTE"
      )
      .forEach((input) => {
        input.addEventListener("change", () => {
          document
            .querySelectorAll("facet-filters-form #" + input.getAttribute("id"))
            .forEach((input2) => {
              input2.value =
                input.value > parseFloat(input.getAttribute("max"))
                  ? parseFloat(input.getAttribute("max"))
                  : input.value;
              document
                .querySelector("#FacetFiltersForm")
                .dispatchEvent(new Event("input"));
            });
        });
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

function reloadPagination() {
  let page = 1;

  if (!document.querySelector("[data-total-count]")) {
    return;
  }

  let current_count = document.querySelector("[data-current-count]").innerHTML;
  let max_count = document.querySelector("[data-total-count]").innerHTML;

  if (current_count == max_count) {
    document
      .querySelectorAll(".collection-show-all, .collection-show-more")
      .forEach((el) => {
        el.classList.add("hidden");
      });
  } else {
    document
      .querySelectorAll(".collection-show-all, .collection-show-more")
      .forEach((el) => {
        el.classList.remove("hidden");
      });
  }

  // checkIfAllProductsAreShowed();

  updateCurrentPage();

  let button_load_more = document.querySelector(".collection-show-more");
  let button_load_all = document.querySelector(".collection-show-all");

  if (button_load_more) {
    button_load_more.addEventListener("click", async function (e) {
      page++;

      let url = window.location.href;
      url += url.includes("?") ? "&" : "?";
      url += "view=ajax";
      url += "&page={page}";

      let new_url = url.replace("{page}", page);

      await fetch(new_url)
        .then((response) => response.text())
        .then((responseText) => {
          let html = new DOMParser().parseFromString(responseText, "text/html");

          let new_products = html.querySelectorAll("product-card");

          new_products.forEach((product, index) => {
            document.querySelector("main-collection").appendChild(product);
          });
        });

      updateProgressBar();
    });
  }

  if (button_load_all) {
    button_load_all.addEventListener("click", async function (e) {
      let has_products = true;
      let url = window.location.href;
      url += url.includes("?") ? "&" : "?";
      url += "view=ajax";
      url += "&page={page}";

      page++;

      while (has_products) {
        let new_url = url.replace("{page}", page);
        await fetch(new_url)
          .then((response) => response.text())
          .then((responseText) => {
            let html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );

            let new_products = html.querySelectorAll("product-card");

            if (new_products.length == 0) {
              has_products = false;
            }

            new_products.forEach((product, index) => {
              document.querySelector("main-collection").appendChild(product);
            });
          });
        page++;
        updateProgressBar();
      }
      updateProgressBar();
    });
  }

  updateProgressBar();

  document
    .querySelector("collection-filters")
    .dispatchEvent(new Event("update"));
}

function updateProgressBar() {
  let progressbar_container = document.querySelector(".collection-progressbar");
  if (progressbar_container) {
    let product_showed = document.querySelectorAll(
      "main-collection product-card"
    ).length;
    let product_total = parseInt(
      document.querySelector("[data-total-count]").innerHTML
    );

    let progress = (product_showed / product_total) * 100;
    document.documentElement.style.setProperty(
      "--collection-progress-bar-width",
      `${progress}%`
    );
    updatePaginationCount();
  }
}


function updatePaginationCount() {
  let product_showed = document.querySelectorAll(
    "main-collection product-card"
  ).length;
  let pagination_count = document.querySelector("[data-current-count]");

  if (product_showed && pagination_count) {
    pagination_count.innerHTML = `${product_showed}`;
  }

  let products_count = document.querySelector("[data-total-count]").innerHTML;
  let current_products_count = document.querySelector(
    "[data-current-count]"
  ).innerHTML;

  if (current_products_count == products_count) {
    document.querySelectorAll(".collection-pagination button").forEach((el) => {
      el.classList.add("hidden");
    });
  }

  // checkIfAllProductsAreShowed();
}

function checkIfAllProductsAreShowed() {
  let products = document.querySelectorAll("main-collection product-card");
  let products_hidden = document.querySelectorAll(
    "main-collection product-card.hidden"
  );

  if (products_hidden.length == 0) {
    document
      .querySelectorAll(".collection-show-more, .collection-show-all")
      .forEach((button) => {
        button.classList.add("hidden");
      });
    updateUrlHistory("all");
  } else {
    return false;
  }
}

function updateUrlHistory(page) {
  let url = new URL(window.location.href);
  url.searchParams.set("current-page", page);
  window.history.pushState({ path: url.href }, "", url.href);
}

function updateCurrentPage() {
  let url = new URL(window.location.href);
  let page = url.searchParams.get("current-page");

  if (page) {
    let product_per_page = parseInt(
      document.querySelector(".collection-show-more").dataset.loadMore
    );

    let products = document.querySelectorAll("main-collection product-card");

    products.forEach((product, index) => {
      if (page == "all") {
        product.classList.remove("hidden");
      } else {
        let p = parseInt(page);
        if (index < product_per_page * p) {
          product.classList.remove("hidden");
        }
      }
    });

    updateProgressBar();
    page++;
  }
}

reloadPagination();

function removeInputTranslateRemove() {
  let input = document.querySelectorAll('[type="checkbox"]');

  input.forEach((el) => {
    if (el.value.indexOf("TO_REMOVE:") > -1) {
      el.value = el.value.replace("TO_REMOVE:", "");
    }
  });
}

removeInputTranslateRemove();
